<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import axios from 'axios';

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Credit Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      filterPayments:{
        customer: '',
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Credit Payments",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Credit Payments",
          active: true,
        },
      ],
      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "customer",
          sortable: true,
          label: 'CUSTOMER',
        },
        {
          key: "amount",
          sortable: true,
          label: 'AMOUNT',
        },
        {
          key: "date",
          sortable: true,
          label: 'DATE',
        },
        {
          key: "mode",
          sortable: true,
          label: 'PAYMENT MODE',
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT_NO",
        },
        {
          key: "recordedby",
          sortable: true,
          label: "RECEIVED_BY",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED_ON",
        }
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("sales", ["filterStatus","SaleCreditPaymentsData","SaleCreditPaymentsPagination","IsSaleCreditPaymentsServerPaginated","SaleCreditPaymentsSummary"]),
    ...mapGetters("customers", ["Customers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IsSaleCreditPaymentsServerPaginated
          ? this.SaleCreditPaymentsPagination.total
          : (this.SaleCreditPaymentsData ? this.SaleCreditPaymentsData.length : 0);
    },

    /**
     * Current page for pagination
     */
    currentPage: {
      get() {
        return this.IsSaleCreditPaymentsServerPaginated ? this.SaleCreditPaymentsPagination.current_page : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsSaleCreditPaymentsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      }
    },

    /**
     * Items per page for pagination
     */
    perPage: {
      get() {
        return this.IsSaleCreditPaymentsServerPaginated ? this.SaleCreditPaymentsPagination.per_page : this.clientPerPage;
      },
      set(value) {
        if (this.IsSaleCreditPaymentsServerPaginated) {
          this.serverPerPage = value;
          this.handlePageChange(1);
        } else {
          this.clientPerPage = value;
        }
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      FetchPayments: "sales/fetchCreditPaymentsData",
      FetchCustomers: "customers/fetchCustomers",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesPaymentsData() {
      const requiresServerPagination = this.filterPayments.datefrom !== this.filterPayments.dateto;

      let payload = {...this.filterPayments};

      if (requiresServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      } else {
        this.clientCurrentPage = 1;
      }

      this.FetchPayments(payload);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      if (!this.IsSaleCreditPaymentsServerPaginated) {
        this.totalRows = filteredItems.length;
        this.clientCurrentPage = 1;
      }
    },

    handlePageChange(newPage) {
      if (this.IsSaleCreditPaymentsServerPaginated) {
        let payload = {
          ...this.filterPayments,
          page: newPage,
          per_page: this.serverPerPage
        };
        this.FetchPayments(payload);
      }
    },

    Excel_export() {
      axios
          .post("export_creditpayments", this.filterPayments,{
            responseType: "arraybuffer",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "credit_payments_report.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.spinner = false;
          })
          .catch(() => {
          });
    },
  },
  updated() {
  },
  watch: {
  },
  created() {
    this.SalesPaymentsData();
    this.FetchCustomers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Credit Payments Report from {{filterPayments.datefrom}} to {{filterPayments.dateto}}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"
                ><i class="fa fa-download"></i> Export Excel</b-button
                >
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                    type="date"
                    v-model="filterPayments.datefrom"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                    v-model="filterPayments.dateto"
                    type="date"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-3">
                <label>CUSTOMERS</label>

                <model-list-select
                    :list="Customers ? [{id: '', name: 'All Customers'},...Customers] : []"
                    v-model="filterPayments.customer"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Customer"
                    @input="SalesPaymentsData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 mt-4">
                <button class="btn btn-primary" type="button" @click="SalesPaymentsData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                    v-if="!IsSaleCreditPaymentsServerPaginated"
                >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <!-- Client-side pagination -->
            <div v-if="!IsSaleCreditPaymentsServerPaginated">
              <b-table
                  class="datatables"
                  :items="SaleCreditPaymentsData?SaleCreditPaymentsData:[]"
              :fields="fields"
              responsive="sm"
              :per-page="clientPerPage"
              :current-page="clientCurrentPage"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              show-empty
              empty-text="No credit payments found for the selected criteria."
              >
              <template #cell(index)="data">
                {{ (clientPerPage * (clientCurrentPage - 1)) + data.index + 1 }}
              </template>

              <template #cell(amount)="data">
                {{thousandSeperator(data.item.amount) }}
              </template>
              <template #table-busy>
                <div class="text-center text-warning my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              </b-table>
            </div>

            <!-- Server-side pagination -->
            <div v-else>
              <table class="table table-striped table-bordered table-responsive nowrap w-100 datatables">
                <thead>
                <tr>
                  <th v-for="field in fields" :key="field.key">
                    {{ field.label }}
                  </th>
                </tr>
                </thead>
                <tbody v-if="!filterStatus && SaleCreditPaymentsData && SaleCreditPaymentsData.length > 0">
                <tr v-for="(item, index) in SaleCreditPaymentsData" :key="item.id">
                  <td>{{ SaleCreditPaymentsPagination.from + index }}</td>
                  <td>{{ item.customer }}</td>
                  <td>{{ thousandSeperator(item.amount) }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.mode }}</td>
                  <td>{{ item.receipt }}</td>
                  <td>{{ item.recordedby }}</td>
                  <td>{{ item.recordedon }}</td>
                </tr>
                </tbody>
                <tbody v-if="filterStatus">
                <tr>
                  <td :colspan="fields.length" class="text-center">
                    <div class="text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-if="!filterStatus && (!SaleCreditPaymentsData || SaleCreditPaymentsData.length === 0)">
                <tr>
                  <td :colspan="fields.length" class="text-center">
                    No credit payments found for the selected criteria.
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <h5>Total Amount: <span class="text-danger">{{thousandSeperator(SaleCreditPaymentsSummary.totalAmount)}}</span></h5>
              </div>
            </div>
          </div>
          <Loader  v-if="!SaleCreditPaymentsData && !filterStatus"/>
          <div class="row">
            <div class="col">
              <div
                  class="dataTables_paginate paging_simple_numbers float-end"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
